import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { FileText, GitBranch, Plus } from "lucide-react";

const STAGES = ["new_lead","assessment_started","assessment_completed","request_received","to_qualify","discovery_booked","discovery_done","shortlist_prep","shortlist_sent","interviews","proposal_prep","proposal_sent","contract_def","project_active","project_done","followup","lost","paused"];

export default function AdminRequests() {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/admin/requests").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const updateStage = async (id, crm_stage) => {
    try { await api.put(`/admin/requests/${id}`, { crm_stage }); toast.success("Stato aggiornato"); refresh(); }
    catch (e) { toast.error("Errore"); }
  };

  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Richieste & CRM</h1>
      <p className="text-sm text-slate-600 mb-6">Pipeline commerciale: tutte le richieste delle aziende e il loro stato.</p>
      <div className="space-y-3">
        {items.map(r => (
          <div key={r.id} className="cxo-card p-5">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#EAF0FF] flex items-center justify-center"><FileText size={20} className="text-[#2D6BFF]" /></div>
              <div className="flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-semibold text-slate-900">{r.title}</h3>
                  <Badge className="bg-[#EAF0FF] text-[#2D6BFF] border-0">{r.crm_stage}</Badge>
                  <Badge variant="outline" className="text-xs">Stato: {r.status}</Badge>
                  <Badge className="bg-amber-100 text-amber-700 border-0">{r.priority}</Badge>
                </div>
                <p className="text-sm text-slate-600 mt-1">{r.company?.company_name} · {r.assessment?.sector}</p>
                <p className="text-xs text-slate-500 mt-1">{r.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
                  <span><strong>Valore atteso:</strong> €{r.expected_value?.toLocaleString('it-IT') || "—"}</span>
                  <span><strong>Probabilità:</strong> {r.probability || 0}%</span>
                </div>
              </div>
              <div className="flex flex-col gap-2 items-end">
                <Select value={r.crm_stage} onValueChange={v => updateStage(r.id, v)}>
                  <SelectTrigger className="w-48 h-9 text-xs"><SelectValue /></SelectTrigger>
                  <SelectContent>{STAGES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                </Select>
                <Link to="/admin/matching"><Button size="sm" className="bg-[#2D6BFF] text-white" data-testid={`go-to-matching-${r.id}`}><GitBranch size={14} className="mr-1" /> Matching</Button></Link>
              </div>
            </div>
          </div>
        ))}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500">Nessuna richiesta</div>}
      </div>
    </div>
  );
}
